// Which line of the catalog a position of the user's games is inside. Pure.

/**
 * The catalog line a suggestion is inside: the suggestion has to have reached the line's starting
 * position. Stopping short of it is not enough, because the moves still missing are what names the
 * opening: at "1.e4 e6 2.d4 d5" White has not chosen between the Advance, the Tarrasch and 3.Nc3 yet.
 *
 * "Is there anything ready to practise that covers this" — not the question a row of a list asks, which is
 * `services/suggestedLines.ts:sameCatalogLine`. It lived in the plan of the day (retired 2026-11-01).
 */
export function relatedCatalogLine<T extends { color: string; uci: string }>(
    catalogLines: T[], suggestion: { uciMoves: string; color: string }): T | null {
    const plies = (uci: string) => uci.split(" ").length;
    return catalogLines
        .filter((line) => line.color === suggestion.color && suggestion.uciMoves.startsWith(line.uci))
        .sort((a, b) => plies(b.uci) - plies(a.uci))[0] || null;
}
